angular.module('TetherApp').factory('notificationService', [
    '$window',
    'ngToast',
    function ($window, ngToast) {

        let getNotifications = function () {
            let notifications = {};
            if ($window.hasOwnProperty('notifications')) {
                notifications = $window.notifications;
            }
            return notifications;
        };

        let getOldNotifications = function () {
            let oldNotifications = {};
            if ($window.hasOwnProperty('old_notifications')) {
                oldNotifications = $window.old_notifications;
            }
            return oldNotifications;
        };

        let getToasts = function (messages) {
            $window.old_notifications = messages;
            for (let index in messages) {
                if (messages.hasOwnProperty(index)) {
                    messages[index].forEach(function(message) {
                        ngToast.create({
                            content: message,
                            className: index,
                            dismissButton: true,
                            dismissButtonHTML: '&times;',
                            dismissOnClick: true,
                            animation: 'fade'   //DOES NOT WORK WHY?
                        });
                    });
                }
            }
        };

        return {
            getNotifications: getNotifications,
            getOldNotifications: getOldNotifications,
            getToasts: getToasts
        }
    }
]);
